import styled from 'styled-components'

export const StyledTimerWrapper = styled.div`
color: white;
.header {
  font-size: calc(20px + 2vmin);
  line-height: 2;
  text-transform: capitalize;
}

.container {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 100%;
  justify-content: center;
}

.timer {
  border-radius: 13px;
  background-color: rgba(255, 255, 255, 0.1);
  display: inline-block;
  text-align: center;
  width: 150px;
}

.col-4 {
  width: 50%;
  float: left;
}

.box {
  border-right: solid 1px rgba(255, 255, 255, 0.2);
  font-weight: 700;
  padding: 10px;
}

.col-4:last-child .box {
  border-right-color: transparent;
}

.box p {
  font-size: calc(16px + 2vmin);
  margin: 0;
}

.text {
  font-size: 14px
}
`
export const CountdownWrapper = styled.div`
display: flex;
 .countdown {
  position: absolute;
  left: 1%;
  top: 10%;
 }
 .text {
  margin-left: 160px;
    font-weight: bold;
    font-size: 18px !important;
 }
`